import React from 'react';
import BackButton from '../buttons/BackButton';
import { useTranslation } from 'react-i18next';

interface LogoHeaderProps {
  bankLogoUrl?: string;
  bankName?: string;
  showBackButton?: boolean;
}

export const LogoHeader = ({ bankLogoUrl, bankName, showBackButton = true }: LogoHeaderProps) => {
  const { t } = useTranslation();
  return (
    <div className="flex items-start justify-between">
      {showBackButton ? <BackButton /> : <div></div>}
      <div className="flex flex-col items-end">
        <p className="!m-0 uppercase text-gray-500 text-xs tracking-widest">{t('Selected Bank')}</p>

        {bankLogoUrl ? (
          <div className="w-[140px] sm:w-30 md:w-40 lg:w-40">
            <img src={bankLogoUrl} alt={bankName || 'Bank logo'} />
          </div>
        ) : (
          <p className="!m-0 text-gray-500 uppercase text-xs tracking-widest align-right">{bankName}</p>
        )}
      </div>
    </div>
  );
};
